/**
 * 2019-04-16
 * handan
 * loading图
 */

import React, { Component, Fragment } from 'react'
import { connect } from "react-redux";
import { Spin, Icon } from "antd";
import "./style.scss";

class Loading extends Component{

  render(){
    const { isShowLoading=false } = this.props
    const antIcon = <Icon type="loading" style={{ fontSize: 38 }} spin />;
    return (
      <Fragment>
        {
          isShowLoading &&
          <div className="Loading-wrap">
            <Spin indicator={antIcon}></Spin>
          </div>
        }
      </Fragment>
    )
  }
}

// Loading.show = () => {
//   this.setState({
//     name: 222
//   })
// }

const mapState = (store) => {
  return {
    isShowLoading: store.loading.isShowLoading,
  }
}
const mapDispatch = (dispatch) => {
  return {

  }
}
export default connect(mapState, mapDispatch)(Loading);